{
  "en": {
    "activerecord": {
      "attributes": {
        "boiler_batch_snapshot": {
          "created_at": "Created At",
          "queue_number": "Queue Number"
        },
        "boiler_batch_snapshot_item": {
          "action": "Action",
          "angle_position": "Angle Position",
          "aux_move_method": "Aux move method",
          "aux_temp": "Aux Temp",
          "aux_time": "Aux Time",
          "command_id": "Cmd ID",
          "end_type": "End Type",
          "item_number": "Item Nr",
          "main_move_method": "Main move method",
          "main_temp": "Main Temp",
          "main_time": "Main Time",
          "mixer_speed": "Mixer Speed",
          "new": "New",
          "processed_at": "Processed At",
          "queued_order_id": "Meal ID",
          "recipe_name": "Recipe",
          "rotation_speed": "Rotation Speed"
        },
        "cooking_mode/move_method": {
          "mix_and_pause": "Mix and pause",
          "mode_10": "Mode 10",
          "mode_3": "Mode 3",
          "mode_4": "Mode 4",
          "mode_5": "Mode 5",
          "mode_6": "Mode 6",
          "mode_7": "Mode 7",
          "mode_8": "Mode 8",
          "mode_9": "Mode 9",
          "no_mixer": "No mixer",
          "standard": "Standard"
        },
        "feeder_dosing_mode": {
          "emergency_steps": "Emergency steps",
          "high_fill_min_percent": "High / medium boundary",
          "levels": "Fill levels",
          "max_acceptable_shortfall_percent": "Maximum acceptable shortfall",
          "medium_fill_min_percent": "Medium / low boundary",
          "unknown_fill_fallback": "Fallback fill level"
        },
        "location": {
          "ai_platform_workspace_id": "AI Platform workspace ID",
          "client_id": "Client ID",
          "client_secret": "Client secret",
          "currency": "Currency",
          "human_working_hours": "Working hours",
          "name": "Name",
          "temperature_scale": "Temperature scale",
          "webhook_url": "Webhook URL",
          "weight_scale": "Weight scale"
        },
        "main_batch_snapshot": {
          "created_at": "Created At"
        },
        "main_batch_snapshot_item": {
          "action": "Action",
          "additional_params": "Additional Params",
          "alt_origin": "Alt Origin",
          "amount": "Amount",
          "boiler_next": "Boiler Next",
          "command_id": "Cmd ID",
          "destination": "Destination",
          "destination_param": "Dest Param",
          "item_number": "Item Nr",
          "new_item": "New",
          "origin": "Origin",
          "origin_param": "Origin Param",
          "processed_at": "Processed At",
          "queue_number": "Queue Nr",
          "queued_order_id": "Meal ID",
          "recipe_name": "Recipe",
          "wait_boiler_cmd_id": "Wait Boiler"
        },
        "product": {
          "alergens": "Alergens",
          "alert": "Alert",
          "dosing_weight_step": "Slow dosing amount",
          "fraction": "Fraction",
          "group": "Group",
          "kcal": "kcal / 100g",
          "kjoul": "kj / 100g",
          "name": "Name",
          "notes": "Notes",
          "processing_loss": "Processing loss",
          "unit": "Unit"
        },
        "recipe": {
          "created_at": "Created",
          "id": "ID",
          "image_url": "Image",
          "menu_category": "Menu category",
          "name": "Name",
          "price": "Price",
          "updated_at": "Modified"
        },
        "recipe_task": {
          "aux_temp": "AUX temperature",
          "main_temp": "Main temperature"
        },
        "sauce_dosing_mode": {
          "high_fill_min_percent": "High / medium boundary",
          "levels": "Fill levels",
          "max_acceptable_shortfall_percent": "Maximum acceptable shortfall",
          "medium_fill_min_percent": "Medium / low boundary",
          "unknown_fill_fallback": "Fallback fill level"
        },
        "setting": {
          "boiler_wait_tolerance_seconds": "Boiler wait tolerance (seconds)",
          "command_log_estimate_calculation_activated": "Calculate command duration estimates from logs",
          "menu_auto_copy_enabled": "Copy menu to next day automatically",
          "order_scheduling_enabled": "Order scheduling enabled",
          "pause_robot_before_boiler_wait_seconds": "Pause robot before boiler wait (seconds, 0 = disabled)",
          "service_session_in_progress": "Service session in progress",
          "skip_robot_commands_in_service_app": "Skip robot commands in service app",
          "sms_notifications_enabled": "SMS notifications enabled"
        }
      },
      "errors": {
        "messages": {
          "draft_version_exists": "another draft already exists",
          "fill_levels_duplicated": "duplicated %{levels}",
          "fill_levels_missing": "missing %{levels}",
          "has_other_versions": "Cannot delete a version that has other versions",
          "not_below_high_fill_boundary": "must be below the high fill boundary",
          "published_version_exists": "another published version already exists",
          "read_only_version": "Published and archived versions are read-only — create a new version instead",
          "record_invalid": "Validation failed: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Cannot delete record because dependent %{record} exist",
            "has_one": "Cannot delete record because a dependent %{record} exists"
          }
        },
        "models": {
          "command_step": {
            "attributes": {
              "base": {
                "step_not_configurable": "Step is not configurable"
              }
            }
          },
          "locker_allocation": {
            "attributes": {
              "base": {
                "unavailable_locker_number": "Unavailable slot number"
              }
            }
          },
          "manually_scheduled_command": {
            "attributes": {
              "base": {
                "boiler_invalid": "Invalid boiler number",
                "service_type_invalid": "Invalid service type"
              }
            }
          },
          "menu": {
            "attributes": {
              "base": {
                "historical_menus_not_destroyable": "Historical menus can't be deleted",
                "historical_menus_not_editable": "Historical menus are not editable",
                "test_recipes_not_allowed": "Move mode test recipes can't be added to a menu: %{names}",
                "unpublished_recipes_not_allowed": "Only published recipes can be added to a menu: %{names}"
              }
            }
          },
          "order": {
            "attributes": {
              "base": {
                "insufficient_batch_recipe_amount": "Insufficient amount of %{recipeName}",
                "insufficient_plate_amount": "Insufficient plate amount",
                "insufficient_product_amount": "Insufficient amount of %{productName}",
                "no_available_time_slots": "No available time slots",
                "recipe_not_in_todays_menu": "Recipe is not in today's menu"
              }
            }
          },
          "order_item": {
            "attributes": {
              "recipe": {
                "not_in_menu": "Recipe not in today's menu",
                "out_of_stock": "Products out of stock"
              }
            }
          },
          "plate_container": {
            "attributes": {
              "amount": {
                "not_positive": "must be a number of bowls greater than zero"
              },
              "initial_amount": {
                "below_zero": "would take more bowls off stand %{slot} than the %{on_stand} it holds",
                "exceeds_stand_capacity": "would leave %{total} bowls on stand %{slot}, which holds %{max}"
              },
              "mode": {
                "unknown": "must be either add or remove"
              }
            }
          },
          "plate_replenishment": {
            "attributes": {
              "amount": {
                "exceeds_stand_capacity": "exceeds bowl stand %{slot} capacity of %{max} — only %{free} more fit",
                "exceeds_stand_capacity_with_pending": "exceeds bowl stand %{slot} capacity of %{max} — %{pending} are already on order, so only %{free} more fit"
              },
              "base": {
                "unavailable_slot_number": "Unavailable slot number"
              }
            }
          },
          "product": {
            "attributes": {
              "feeder_dosing_mode": {
                "not_published": "must be a published version"
              },
              "sauce_dosing_mode": {
                "not_published": "must be a published version"
              }
            }
          },
          "product_category": {
            "attributes": {
              "base": {
                "destroy_category_with_products": "Cannot delete category with existing products.",
                "invalid_batch_recipes_category_level": "Batch Recipe category must be on level 1",
                "invalid_category_level": "Product categories can be nested up to 2 levels.",
                "unique_batch_recipes_category": "Only one Batch Recipe category allowed",
                "zero_product_amount_error": "Amount of ingredient can't be 0"
              }
            }
          },
          "product_container": {
            "attributes": {
              "base": {
                "active_container_exists": "Slot %{slot} already has an active container. Remove it before adding a new one.",
                "container_replace_failed": "Could not replace the container. Please try again."
              },
              "initial_amount": {
                "above_max_container_amount": "can't be more than the product's max container amount (%{max})"
              },
              "product_id": {
                "invalid_product_type": "Invalid product type"
              }
            }
          },
          "product_replenishment": {
            "attributes": {
              "base": {
                "unavailable_slot_number": "Unavailable slot number"
              }
            }
          },
          "recipe": {
            "attributes": {
              "base": {
                "archived_not_editable": "Archived recipes are read-only",
                "destroy_active_orders_error": "Recipes with active orders are not destroyable!",
                "destroy_existing_menu_error": "Recipes with existing menus are not destroyable!",
                "missing_cook_time_in_boiler_tasks": "At least one Set cooking mode task needed in boiler tasks",
                "published_not_editable": "Published recipes are read-only. Create a new version to make changes.",
                "zero_product_amount_error": "Amount of ingredient can't be 0"
              },
              "status": {
                "draft_version_exists": "a draft already exists for this recipe",
                "published_version_exists": "another version of this recipe is already published"
              }
            }
          },
          "recipe_task": {
            "attributes": {
              "aux_temp": {
                "must_be_greater_than": {
                  "celsius": "must be at least 0°C",
                  "fahrenheit": "must be at least 32°F"
                }
              },
              "main_temp": {
                "must_be_greater_than": {
                  "celsius": "must be at least 0°C",
                  "fahrenheit": "must be at least 32°F"
                }
              }
            }
          },
          "recipe_task_product": {
            "attributes": {
              "base": {
                "product_nor_recipe_provided_error": "Either product or batch recipe have to be provided"
              }
            }
          },
          "replenishment_order": {
            "attributes": {
              "base": {
                "active_order_on_location": "Active order for your location already exists",
                "cannot_edit_not_draft": "Sent orders are not editable",
                "empty_order": "Order must have at least one item",
                "invalid_product_type": "Invalid product type"
              },
              "delivery_date": {
                "delivery_date_in_past": "can't be in past",
                "delivery_date_nil": "must exist"
              }
            }
          },
          "verification": {
            "attributes": {
              "base": {
                "missing_object": "%{name} is missing",
                "product_mismatch": "Invalid container (expected: '%{expected}', got: '%{actual}')",
                "slot_mismatch": "Invalid slot (expected: '%{expected}', got: '%{actual}')"
              }
            }
          }
        }
      },
      "models": {
        "boiler_batch_snapshot": "Boiler Batch Snapshot",
        "boiler_batch_snapshot_item": "Boiler Batch Snapshot Item",
        "main_batch_snapshot": "Main Batch Snapshot",
        "main_batch_snapshot_item": "Main Batch Snapshot Item",
        "product": "Product",
        "recipe": "Recipe"
      }
    },
    "admin": {
      "batch_snapshot_items": {
        "title": "Batch Snapshot"
      },
      "boiler_batch_snapshots": {
        "title": "Boiler Batch Snapshots"
      },
      "main_batch_snapshots": {
        "title": "Main Batch Snapshots"
      },
      "monitor": {
        "boiler": "Boiler",
        "boiler_buffer": "Boiler buffer",
        "command_logs": "Logs",
        "command_logs_humanized": "Logs (readable)",
        "lockers": "Lockers",
        "robot": "Robot",
        "robot_buffer": "Robot buffer",
        "settings": "Settings",
        "system": "System",
        "value": "Value",
        "variable": "Variable"
      },
      "settings": {
        "action_enqueued": {
          "wash_boiler": "Boiler #%{boiler_nr} wash enqueued",
          "wash_gripper": "Gripper wash enqueued"
        },
        "action_names": {
          "wash_boiler": "Wash boiler #%{boiler_nr}",
          "wash_gripper": "Wash gripper"
        },
        "actions": "Actions",
        "add_to_queue": "Add to queue",
        "clear_mobile_app_tasks": "Clear service app tasks",
        "close_locker": "Close",
        "force_finish_service_session": "Force finish active service session",
        "locker_action_performed": {
          "close_all_lockers": "Closed all lockers",
          "close_locker": "Locker #%{locker_nr} closed",
          "open_all_lockers": "Opened all lockers",
          "open_locker": "Locker #%{locker_nr} opened"
        },
        "mark_robot_as_reset": "Mark robot as reset",
        "open_locker": "Open",
        "perform_asap": "Perform ASAP",
        "plate_stand_action_performed": {
          "reset_plate_stand": "Plate stand #%{stand_nr} reset successfully"
        },
        "reset_cooker": "Reset",
        "reset_cooker_performed": "Boiler #%{boiler_nr} reset successfully",
        "reset_performed": {
          "mark_robot_as_reset": "Robot marked as reset",
          "reset_simulator": "Simulator has been reset"
        },
        "reset_plate_stand": "Reset Plate Stand",
        "reset_simulator": "Reset simulator",
        "select_priority_prompt": "Please select \"%{action_name}\" technical order priority",
        "service_session_action_confirm": {
          "clear_mobile_app_tasks": "This cancels every not-completed replenishment task shown in the mobile app. Continue?"
        },
        "service_session_action_performed": {
          "clear_mobile_app_tasks": "Canceled %{count} service app tasks",
          "force_finish_service_session": "Service session finished"
        },
        "service_tasks_generated": "Scheduled service task execution generation",
        "settings": "Settings",
        "settings_updated": "Settings updated",
        "system": "System",
        "wash_boiler": "Wash",
        "wash_gripper": "Wash gripper"
      }
    },
    "alergens": {
      "no_records_heading": "No alergens yet"
    },
    "ancestry": {
      "cannot_delete_descendants": "Cannot delete record because it has descendants.",
      "cannot_rebuild_depth_cache": "Cannot rebuild depth cache for model without depth caching.",
      "conflicting_parent_id": "Conflicting parent id found in node %{node_id}: %{parent_id} for node %{node_id} while expecting %{expected}",
      "exclude_self": "%{class_name} cannot be a descendant of itself.",
      "invalid_ancestry_column": "Invalid format for ancestry column of node %{node_id}: %{ancestry_column}.",
      "invalid_orphan_strategy": "Invalid orphan strategy, valid ones are :rootify, :adopt, :restrict and :destroy.",
      "named_scope_depth_cache": "Named scope '%{scope_name}' is only available when depth caching is enabled.",
      "no_child_for_new_record": "No child ancestry for new record. Save record before performing tree operations.",
      "option_must_be_hash": "Options for has_ancestry must be in a hash.",
      "reference_nonexistent_node": "Reference to nonexistent node in node %{node_id}: %{ancestor_id}.",
      "unknown_depth_option": "Unknown depth option: %{scope_name}.",
      "unknown_format": "Unknown ancestry format: %{value}.",
      "unknown_option": "Unknown option for has_ancestry: %{key} => %{value}."
    },
    "back": "Back",
    "cancel": "Cancel",
    "catalogue": {
      "add_image": "Add image",
      "add_new": "+ Add New",
      "all_categories": "All categories",
      "category_name": "Category name",
      "change_image": "Change image",
      "columns_updated": "Columns updated",
      "create": "Create %{type}",
      "delete": "Delete %{type}",
      "delete_dialog": {
        "confirm": "Delete",
        "deleted": "%{type} deleted",
        "deleted_message": "%{type} was successfully deleted",
        "failed": "Failed to delete",
        "failed_message": "%{type} could not be deleted - %{message}",
        "title": "Delete %{type}!"
      },
      "done": "Done",
      "drag_to_reposition": "Drag to reposition",
      "edit": "Edit %{type}",
      "external_id": "%{provider} External ID",
      "feeder_types": {
        "liquid": "Liquid",
        "solid": "Solid"
      },
      "infor_not_synced": "Infor not synced",
      "last_synced_at": "Last synced at: %{time}",
      "positions_updated": "Positions updated",
      "products_count": {
        "one": "( %{count} product )",
        "other": "( %{count} products )"
      },
      "request_failed": "Request failed",
      "sections": {
        "basic_info": "BASIC INFO",
        "dosing_settings": "DOSING SETTINGS",
        "feeder_configuration": "FEEDER CONFIGURATION",
        "modifier_and_integration": "MODIFIER & INTEGRATION",
        "nutrition_and_allergens": "NUTRITION & ALLERGENS"
      },
      "toggle_subcategories": "Toggle subcategories",
      "unsaved_changes": "Changes on the form have not been saved. Proceed?"
    },
    "categories": "Categories",
    "category": "Category",
    "close": "Close",
    "command_history": {
      "actual_dosed": "Actual dosed",
      "actual_duration": "Actual duration",
      "all_attempts": "All attempts",
      "all_categories": "All categories",
      "all_feeders": "All feeders",
      "all_types": "All types",
      "any_deviation": "Any deviation",
      "any_duration": "Any length",
      "attempts": "Attempts",
      "avg_bias": "Avg bias",
      "avg_cycle": "Avg cycle",
      "avg_deviation": "Avg deviation",
      "avg_rate": "Avg rate",
      "backup_fallbacks": "Backup fallbacks",
      "backup_only": "Used backup feeder",
      "backup_used": "Backup",
      "by_feeder": {
        "one": "Break down by feeder (%{count} feeder)",
        "other": "Break down by feeder (%{count} feeders)"
      },
      "clear": "Clear (remove filter)",
      "clear_filters": {
        "one": "Clear %{count} filter",
        "other": "Clear %{count} filters"
      },
      "command": "command",
      "command_durations_history": "Command durations history",
      "command_history_sheet": "Command history",
      "command_name": "Command name",
      "command_step": "command step",
      "command_steps": "Command steps",
      "commands": "Commands",
      "cycle_time": "Cycle",
      "date_range": "Date range",
      "day": "Day",
      "detailed_filter": "Detailed filter",
      "deviation": "Deviation",
      "difference": "Difference",
      "dose_size": "Dose size",
      "dosing_amount_history": "Dosing amount history",
      "dosing_rate": "Rate",
      "dosing_time": "Reported / est.",
      "dosing_type": "Dosing type",
      "estimated_duration": "Estimated duration",
      "executed_at": "Executed at",
      "export_capped": "capped at %{max} - narrow the date range for the rest",
      "export_default_date_range": "Last 30 days (default)",
      "export_rows": "Rows",
      "export_to_excel": "Export to Excel",
      "export_view": "View",
      "failed": "Failed",
      "failure_rate": "Failure rate",
      "failures": "Failures",
      "failures_only": "Failures only",
      "feeder": "Feeder",
      "feeder_slot": "Feeder slot",
      "from": "From",
      "graph_view": "Graph view",
      "group_data_by": "Group data by ",
      "help_avg_bias": "Average signed deviation. Near zero means misses cancel out; a consistently positive or negative value means the feeder is systematically over- or under-dosing and needs recalibration.\n",
      "help_avg_cycle": "Average elapsed time of the whole dosing command, from approaching the feeder to the last substep reported. The dosing substep itself is only a completion marker, so this is the one duration that actually varies — the p90 shows the slow tail.\n",
      "help_avg_deviation": "Average distance from the recipe amount, ignoring direction, so over- and under-dosing cannot cancel out. The median next to it is less sensitive to a few extreme misses.\n",
      "help_avg_rate": "Amount dosed per second of command cycle. A falling rate for a feeder is an early sign of mechanical wear. The sub-line is what the planner currently expects the dosing step to take.\n",
      "help_backup_fallbacks": "Doses that drew from more than one container, meaning the primary feeder could not deliver and the robot fell back to the backup.\n",
      "help_doses": "How many ingredient doses the current filters cover. One dose is one ingredient of one meal; if it took several tries it still counts once, and the sub-line shows the total number of individual attempts.\n",
      "help_failure_rate": "Share of doses where at least one attempt reported a dosing failure. Of those, \"never dosed\" are the ones that never succeeded at all — not even from the backup feeder — so the ingredient is missing from the meal.\n",
      "help_on_target": "Share of doses whose total landed within ±%{tolerance}% of the amount the recipe asks for. Only doses with a positive planned amount are counted.\n",
      "invalid_date_filter": "The date filter could not be read, so nothing was exported.",
      "invalid_search_option": "Invalid search option for durations table",
      "last_dose": "Last dose",
      "left_before_dose": "Left before dose",
      "max": "Max",
      "max_cycle": "Slowest cycle",
      "min": "Min",
      "min_cycle": "Cycle length",
      "month": "Month",
      "more_filters": "More filters",
      "needed_to_dose": "Needed to dose",
      "next_day": "Next day",
      "next_month": "Next month",
      "next_week": "Next week",
      "next_year": "Next year",
      "on_target": "On target",
      "on_target_only": "On target only",
      "optional": "(optional)",
      "outcome": "Outcome",
      "over_dosed_only": "Over-dosed only",
      "previous_day": "Previous day",
      "previous_month": "Previous month",
      "previous_week": "Previous week",
      "previous_year": "Previous year",
      "product_category": "Product category",
      "product_name": "Product name",
      "products": "Products",
      "queued_order_id": "Queued order ID",
      "queued_orders": "Queued orders",
      "recipe_name": "Recipe name",
      "result": "Result",
      "retried_only": "Retried only",
      "sauce": "All sauces (liquid)",
      "search": "Search",
      "search_by": "Search by",
      "select_specific": "Select specific",
      "slower_than": "Slower than %{seconds}s",
      "solid": "All solids (feeder)",
      "standard_filter": "Standard filter",
      "step_name": "Step name",
      "summary_attempts": {
        "one": "%{count} attempt",
        "other": "%{count} attempts"
      },
      "summary_bias_hint": "signed: over/under-dosing",
      "summary_cycle_tail": "p90 %{p90}",
      "summary_doses": "Doses",
      "summary_estimate": "planner expects %{estimate}",
      "summary_failed": "%{failed} failed, %{unrecovered} never dosed",
      "summary_fallback_hint": "doses that switched container",
      "summary_median": "median %{median}",
      "summary_tolerance": "within ±%{tolerance}%, n=%{count}",
      "table_view": "Table view",
      "time_difference": "Time difference",
      "time_of_day": "Time of day",
      "time_period": "Time period",
      "time_since_last_command": "Time since last command",
      "to": "To",
      "total_dosed": "Total dosed",
      "under_dosed_only": "Under-dosed only",
      "week": "Week",
      "year": "Year"
    },
    "command_steps": {
      "back_to_commands": "Back to all commands",
      "configure_substeps": "Configure substeps",
      "depends_on_product_container": "Depends on product container",
      "duration_unit": "Duration unit",
      "edit_command_steps": "Edit command steps",
      "invalid_duration": "Duration must be greater than 0",
      "name": "Name",
      "not_configurable": "Not configurable",
      "robot_commands": "Robot commands",
      "seconds": "seconds",
      "seconds_per_product": "seconds for 100g of product",
      "step_duration": "Step duration",
      "step_name": "Step name",
      "step_number": "Step number",
      "step_updated_successfully": "Command step updated successfully",
      "value": "Value",
      "variable_duration": "Variable duration"
    },
    "comments": {
      "add": "Add comment",
      "comment": "Comment",
      "delete": "Delete",
      "delete_confirm": "Delete this comment?",
      "delete_failed": "Could not delete the comment.",
      "edit": "Edit",
      "edited": "(edited)",
      "empty": "No comments yet",
      "rate_aria": "Rate %{star} of 5",
      "rating": "Rating",
      "rating_aria": "Rated %{value} of 5",
      "save_failed": "Could not save comment. Please review the values.",
      "submit": "Save comment",
      "tagging": {
        "label": "Tested with",
        "loading": "Loading %{tags}…",
        "none": "No %{tags}",
        "organization": "Organization",
        "select": "Select %{tags}",
        "select_organization": "Select organization to filter %{tags}"
      },
      "title": "Comments"
    },
    "confirmation": {
      "line1": "Are you sure you want to proceed?",
      "line2": "This cannot be undone!"
    },
    "continue": "Continue",
    "controls": {
      "actions": "Actions",
      "cancel": "Cancel",
      "canceling_session": "Canceling operator service session…",
      "command_executed": "%{command} executed successfully",
      "command_scheduled": "%{command} scheduled",
      "confirm_emergency_stop": "Emergency stop disables the robot and all cookers. Meals currently being made will be canceled and their customers notified. Queued orders will wait until the robot is started again. Continue?",
      "confirm_emergency_stop_button": "Emergency stop",
      "confirm_execute": "Execute %{name}?",
      "confirm_execute_button": "Execute",
      "confirm_execute_title": "Confirm action",
      "control_status": {
        "connected": "Connected",
        "disconnected": "Disconnected",
        "door_safety": "Door safety",
        "faulty_dispenser_tooltip": "Faulty dispenser: %{list}",
        "faulty_tooltip": "Faulty: %{list}",
        "indicators": {
          "bowls": "B",
          "door_safety_armed": "Armed",
          "door_safety_unarmed": "Unarmed",
          "fixed_feeders": "F",
          "mobile_feeders": "M",
          "oil": "O",
          "sewage": "SEW",
          "tray": "TRAY"
        },
        "last_update_tooltip": "Latest update at %{time}",
        "low_bowl_tooltip": "Low bowl stock: %{list}",
        "low_fixed_feeder_tooltip": "Low fixed feeder stock: %{list}",
        "low_mobile_feeder_tooltip": "Low mobile feeder stock: %{list}",
        "never_updated": "No updates yet",
        "sections": {
          "cookers": "Cookers",
          "doors": "Doors",
          "ingredients": "Ingredients",
          "utilities": "Utilities"
        },
        "status": "Status",
        "temp_ok": "Temp OK",
        "temp_problem": "Temp Problem"
      },
      "emergency_restart_pending": "Robot start requested — the robot will start within a few seconds.",
      "emergency_stop_active": "EMERGENCY STOP ACTIVE — clean up the kitchen manually, then press Start robot.",
      "end_session": "End operator service session",
      "ending_session": "Ending operator service session…",
      "errors": {
        "end_session": "Failed to end service session",
        "execute_command": "Command failed",
        "load_scales": "Failed to load weight",
        "load_status": "Failed to load status",
        "start_session": "Failed to start service session"
      },
      "groups": {
        "cookers": "Cookers",
        "doors": "Door opening",
        "lockers": "Lockers",
        "orders": "Order intake",
        "robot_and_gripper": "Robot & gripper",
        "sewage": "Sewage",
        "tray": "Tray"
      },
      "kitchen_config_discard_confirm": "You have unsaved kitchen configuration changes. Discard them?",
      "kitchen_config_heading": "Kitchen configuration",
      "kitchen_config_load_failed": "Failed to load kitchen configuration",
      "kitchen_config_save": "Save changes",
      "kitchen_config_save_failed": "Failed to save kitchen configuration",
      "kitchen_config_saved": "Kitchen configuration saved",
      "kitchen_config_sections": {
        "cooking_units": "Cooking units",
        "fixed_container_slots": "Fixed feeders",
        "locker_slots": "Lockers",
        "mobile_container_slots": "Mobile feeders",
        "plate_stands": "Plate stands",
        "robot_trays": "Robot trays"
      },
      "locker_state_tooltips": {
        "blocked": "Holds a cup from a robot reset — open it and take the cup out",
        "cooling_down": "Open; will close automatically within a minute",
        "disabled": "Disabled",
        "door_open": "Door is open",
        "free": "Available",
        "occupied": "Meal inside, not ready yet",
        "ready": "Meal finished and waiting",
        "reserved": "Reserved for a meal"
      },
      "locker_states": {
        "blocked": "Blocked",
        "cooling_down": "Closing",
        "disabled": "Disabled",
        "free": "Free",
        "occupied": "Occupied",
        "ready": "Ready",
        "reserved": "Reserved"
      },
      "orders_stopped_active": "CLOSED FOR ORDERS — the menu is hidden from the POS and vouchers cannot be redeemed. Orders already received will be completed.",
      "orders_stopped_robot_not_executing": "CLOSED FOR ORDERS — the robot has not executed orders since %{since}. The menu is hidden from the POS and vouchers cannot be redeemed. Orders already received will be completed once the robot works again. Check the robot, then press Resume receiving orders.",
      "pending_body": "Robot is finishing current tasks.",
      "pending_title": "Operator service session pending",
      "retrying_in": "Retrying in %{seconds}s…",
      "scales_heading": "Weight scales",
      "scales_loading": "Loading…",
      "scales_refresh": "Refresh",
      "scales_unavailable": "Unavailable",
      "service_session_types": {
        "cleaning": "Cleaning",
        "forced_replenishment": "Forced replenishment",
        "maintenance": "Maintenance",
        "move_mode_testing": "Move mode testing",
        "operator": "Operator",
        "replenishment": "Replenishment",
        "unknown": "Another"
      },
      "session_active": "Operator service session in progress",
      "session_blocked_banner": "%{session_type} service session is in progress — the robot is held by it until it is ended where it was started",
      "session_blocked_tooltip": "%{session_type} service session already in progress",
      "session_idle": "No active operator service session",
      "session_only_tooltip": "This command can be executed only during an active operator service session",
      "slot_alerts_empty": "No alerts recorded for this part.",
      "slot_alerts_failed": "Failed to load alerts",
      "slot_alerts_loading": "Loading alerts…",
      "slot_alerts_loading_more": "Loading more…",
      "slot_alerts_modal_title": "Alerts for slot %{slot}",
      "start_session": "Start operator service session",
      "starting_session": "Starting operator service session…",
      "status": "Status",
      "status_indicators": {
        "details": {
          "closed": "Closed",
          "disabled": "Disabled",
          "error": "Error",
          "full": "Full",
          "half": "Half",
          "locked": "Locked",
          "low": "Low",
          "open": "Open",
          "unknown": "Unknown",
          "unlocked": "Unlocked"
        }
      }
    },
    "cooking_modes": {
      "no_records_heading": "No cooking modes yet"
    },
    "currencies": {
      "code": "Code",
      "created": {
        "success": "Currency created"
      },
      "currencies": "Currencies",
      "currency": "Currency",
      "deleted": {
        "error": "Currencies that are assigned to locations cannot be deleted.",
        "success": "Currency deleted"
      },
      "symbol": "Symbol",
      "updated": {
        "success": "Currency updated"
      }
    },
    "custom_vision": {
      "created_at": "Created",
      "description": "Description",
      "modified_at": "Modified",
      "project": "Project"
    },
    "customer_support": {
      "back": "Back",
      "candidates_description": "We found orders that may match the information you provided. Please select your order.",
      "candidates_title": "Is this your order?",
      "confirm_order": "This is my order",
      "confirming": "Updating…",
      "continue": "Continue",
      "description": "To help you, please enter your phone number.",
      "errors": {
        "invalid_phone_number": "Please enter a valid phone number.",
        "no_order_for_meal": "Unfortunately, we couldn't find information about your order. Please go to Atrium cafe for assistance.",
        "no_order_for_phone_number": "Unfortunately, we couldn't find any orders associated with your phone number. Please select at least one meal that you ordered.",
        "not_correctable": "Unfortunately, we couldn't find information about your order. Please go to Atrium cafe for assistance.",
        "select_a_meal": "Please select at least one meal."
      },
      "find_my_order": "Find my order",
      "found_title": "We found your order",
      "meal_id": "ID #%{id}",
      "no_meals": "There is no menu for today, so we cannot look your order up by meal.",
      "not_found_title": "We couldn't find your order",
      "order_number": "Order #%{number}",
      "phone_number_label": "Phone number",
      "phone_number_placeholder": "(555) 000-0000",
      "privacy_note": "We'll only use this to find your order.",
      "search_meals": "Search meals",
      "searching": "Searching…",
      "sms_sent": "We've sent the tracking link to your phone.",
      "statuses": {
        "being_prepared": "Being prepared",
        "ready_for_pickup": "Ready for pickup"
      },
      "title": "Customer Support",
      "view_order": "View order"
    },
    "date": {
      "abbr_day_names": [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "full": "%Y-%m-%d",
        "long": "%B %d, %Y",
        "month_name": "%B",
        "short": "%b %d",
        "year_and_month": "%Y-%m"
      },
      "month_names": [
        null,
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "about 1 hour",
          "other": "about %{count} hours"
        },
        "about_x_months": {
          "one": "about 1 month",
          "other": "about %{count} months"
        },
        "about_x_years": {
          "one": "about 1 year",
          "other": "about %{count} years"
        },
        "almost_x_years": {
          "one": "almost 1 year",
          "other": "almost %{count} years"
        },
        "half_a_minute": "half a minute",
        "less_than_x_minutes": {
          "one": "less than a minute",
          "other": "less than %{count} minutes"
        },
        "less_than_x_seconds": {
          "one": "less than 1 second",
          "other": "less than %{count} seconds"
        },
        "over_x_years": {
          "one": "over 1 year",
          "other": "over %{count} years"
        },
        "x_days": {
          "one": "1 day",
          "other": "%{count} days"
        },
        "x_minutes": {
          "one": "1 minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "1 month",
          "other": "%{count} months"
        },
        "x_seconds": {
          "one": "1 second",
          "other": "%{count} seconds"
        }
      },
      "prompts": {
        "day": "Day",
        "hour": "Hour",
        "minute": "Minute",
        "month": "Month",
        "second": "Seconds",
        "year": "Year"
      },
      "relative": {
        "future": "in %{time}",
        "past": "%{time} ago"
      }
    },
    "destroy_error": "Record was not destroyed",
    "destroy_success": "Record destroyed successfully",
    "devise": {
      "confirmations": {
        "confirmed": "Your email address has been successfully confirmed.",
        "send_instructions": "You will receive an email with instructions for how to confirm your email address in a few minutes.",
        "send_paranoid_instructions": "If your email address exists in our database, you will receive an email with instructions for how to confirm your email address in a few minutes."
      },
      "failure": {
        "already_authenticated": "You are already signed in.",
        "inactive": "Your account is not activated yet.",
        "invalid": "Invalid %{authentication_keys} or password.",
        "last_attempt": "You have one more attempt before your account is locked.",
        "locked": "Your account is locked.",
        "not_found_in_database": "Invalid %{authentication_keys} or password.",
        "timeout": "Your session expired. Please sign in again to continue.",
        "unauthenticated": "You need to sign in or sign up before continuing.",
        "unconfirmed": "You have to confirm your email address before continuing."
      },
      "mailer": {
        "confirmation_instructions": {
          "subject": "Confirmation instructions"
        },
        "email_changed": {
          "subject": "Email Changed"
        },
        "password_change": {
          "subject": "Password Changed"
        },
        "reset_password_instructions": {
          "subject": "Reset password instructions"
        },
        "unlock_instructions": {
          "subject": "Unlock instructions"
        }
      },
      "omniauth_callbacks": {
        "failure": "Could not authenticate you from %{kind} because \"%{reason}\".",
        "success": "Successfully authenticated from %{kind} account."
      },
      "passwords": {
        "no_token": "You can't access this page without coming from a password reset email. If you do come from a password reset email, please make sure you used the full URL provided.",
        "send_instructions": "You will receive an email with instructions on how to reset your password in a few minutes.",
        "send_paranoid_instructions": "If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes.",
        "updated": "Your password has been changed successfully. You are now signed in.",
        "updated_not_active": "Your password has been changed successfully."
      },
      "registrations": {
        "destroyed": "Bye! Your account has been successfully cancelled. We hope to see you again soon.",
        "signed_up": "Welcome! You have signed up successfully.",
        "signed_up_but_inactive": "You have signed up successfully. However, we could not sign you in because your account is not yet activated.",
        "signed_up_but_locked": "You have signed up successfully. However, we could not sign you in because your account is locked.",
        "signed_up_but_unconfirmed": "A message with a confirmation link has been sent to your email address. Please follow the link to activate your account.",
        "update_needs_confirmation": "You updated your account successfully, but we need to verify your new email address. Please check your email and follow the confirm link to confirm your new email address.",
        "updated": "Your account has been updated successfully.",
        "updated_but_not_signed_in": "Your account has been updated successfully, but since your password was changed, you need to sign in again"
      },
      "sessions": {
        "already_signed_out": "Signed out successfully.",
        "signed_in": "Signed in successfully.",
        "signed_out": "Signed out successfully."
      },
      "unlocks": {
        "send_instructions": "You will receive an email with instructions for how to unlock your account in a few minutes.",
        "send_paranoid_instructions": "If your account exists, you will receive an email with instructions for how to unlock it in a few minutes.",
        "unlocked": "Your account has been unlocked successfully. Please sign in to continue."
      }
    },
    "dosing_mode_usage": {
      "dose_count": {
        "one": "%{count} dose in the last 30 days",
        "other": "%{count} doses in the last 30 days"
      },
      "empty": "No product uses this version, and it has not dosed anything in the last 30 days.",
      "no_longer_assigned": "no longer assigned",
      "product_count": {
        "one": "Used by %{count} product",
        "other": "Used by %{count} products"
      },
      "row_dose_count": {
        "one": "%{count} dose (30d)",
        "other": "%{count} doses (30d)"
      },
      "summary": "%{products} · %{doses}",
      "title": "Usage"
    },
    "error_modal": {
      "button": "Return",
      "title": "Something went wrong"
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "must be accepted",
        "already_confirmed": "was already confirmed, please try signing in",
        "aspect_ratio_invalid": "has an invalid aspect ratio (valid aspect ratios are %{authorized_aspect_ratios})",
        "aspect_ratio_not_landscape": "must be landscape (current file is %{width}x%{height}px)",
        "aspect_ratio_not_portrait": "must be portrait (current file is %{width}x%{height}px)",
        "aspect_ratio_not_square": "must be square (current file is %{width}x%{height}px)",
        "aspect_ratio_not_x_y": "must be %{authorized_aspect_ratios} (current file is %{width}x%{height}px)",
        "attachment_missing": "is missing its attachment",
        "blank": "can't be blank",
        "confirmation": "doesn't match %{attribute}",
        "confirmation_period_expired": "needs to be confirmed within %{period}, please request a new one",
        "content_type_invalid": {
          "one": "has an invalid content type (authorized content type is %{authorized_human_content_types})",
          "other": "has an invalid content type (authorized content types are %{authorized_human_content_types})"
        },
        "content_type_spoofed": {
          "one": "has a content type that is not equivalent to the one that is detected through its content (authorized content type is %{authorized_human_content_types})",
          "other": "has a content type that is not equivalent to the one that is detected through its content (authorized content types are %{authorized_human_content_types})"
        },
        "dimension_height_not_equal_to": "height must be equal to %{length} pixels",
        "dimension_height_not_greater_than_or_equal_to": "height must be greater than or equal to %{length} pixels",
        "dimension_height_not_included_in": "height is not included between %{min} and %{max} pixels",
        "dimension_height_not_less_than_or_equal_to": "height must be less than or equal to %{length} pixels",
        "dimension_max_not_included_in": "must be less than or equal to %{width} x %{height} pixels",
        "dimension_min_not_included_in": "must be greater than or equal to %{width} x %{height} pixels",
        "dimension_width_not_equal_to": "width must be equal to %{length} pixels",
        "dimension_width_not_greater_than_or_equal_to": "width must be greater than or equal to %{length} pixels",
        "dimension_width_not_included_in": "width is not included between %{min} and %{max} pixels",
        "dimension_width_not_less_than_or_equal_to": "width must be less than or equal to %{length} pixels",
        "duration_not_between": "duration must be between %{min} and %{max} (current duration is %{duration})",
        "duration_not_equal_to": "duration must be equal to %{exact} (current duration is %{duration})",
        "duration_not_greater_than": "duration must be greater than %{min} (current duration is %{duration})",
        "duration_not_greater_than_or_equal_to": "duration must be greater than or equal to %{min} (current duration is %{duration})",
        "duration_not_less_than": "duration must be less than %{max} (current duration is %{duration})",
        "duration_not_less_than_or_equal_to": "duration must be less than or equal to %{max} (current duration is %{duration})",
        "empty": "can't be empty",
        "equal_to": "must be equal to %{count}",
        "even": "must be even",
        "exclusion": "is reserved",
        "expired": "has expired, please request a new one",
        "file_not_processable": "is not identified as a valid media file",
        "file_size_not_between": "file size must be between %{min} and %{max} (current size is %{file_size})",
        "file_size_not_equal_to": "file size must be equal to %{exact} (current size is %{file_size})",
        "file_size_not_greater_than": "file size must be greater than %{min} (current size is %{file_size})",
        "file_size_not_greater_than_or_equal_to": "file size must be greater than or equal to %{min} (current size is %{file_size})",
        "file_size_not_less_than": "file size must be less than %{max} (current size is %{file_size})",
        "file_size_not_less_than_or_equal_to": "file size must be less than or equal to %{max} (current size is %{file_size})",
        "greater_than": "must be greater than %{count}",
        "greater_than_or_equal_to": "must be greater than or equal to %{count}",
        "in": "must be in %{count}",
        "inclusion": "is not included in the list",
        "invalid": "is invalid",
        "less_than": "must be less than %{count}",
        "less_than_or_equal_to": "must be less than or equal to %{count}",
        "limit_max_exceeded": {
          "one": "too many files attached (maximum is %{max} files, got %{count})",
          "other": "too many files attached (maximum is %{max} files, got %{count})",
          "zero": "no files attached (maximum is %{max} files)"
        },
        "limit_min_not_reached": {
          "one": "only 1 file attached (must have at least %{min} files)",
          "other": "%{count} files attached (must have at least %{min} files)",
          "zero": "no files attached (must have at least %{min} files)"
        },
        "limit_out_of_range": {
          "one": "only 1 file attached (must have between %{min} and %{max} files)",
          "other": "total number of files must be between %{min} and %{max} files (there are %{count} files attached)",
          "zero": "no files attached (must have between %{min} and %{max} files)"
        },
        "media_metadata_missing": "is not a valid media file",
        "model_invalid": "Validation failed: %{errors}",
        "not_a_number": "is not a number",
        "not_an_integer": "must be an integer",
        "not_found": "not found",
        "not_locked": "was not locked",
        "not_saved": {
          "one": "1 error prohibited this %{resource} from being saved:",
          "other": "%{count} errors prohibited this %{resource} from being saved:"
        },
        "odd": "must be odd",
        "other_than": "must be other than %{count}",
        "pages_not_between": "page count must be between %{min} and %{max} (current page count is %{pages})",
        "pages_not_equal_to": "page count must be equal to %{exact} (current page count is %{pages})",
        "pages_not_greater_than": "page count must be greater than %{min} (current page count is %{pages})",
        "pages_not_greater_than_or_equal_to": "page count must be greater than or equal to %{min} (current page count is %{pages})",
        "pages_not_less_than": "page count must be less than %{max} (current page count is %{pages})",
        "pages_not_less_than_or_equal_to": "page count must be less than or equal to %{max} (current page count is %{pages})",
        "password_too_long": "is too long",
        "present": "must be blank",
        "required": "must exist",
        "taken": "has already been taken",
        "too_long": {
          "one": "is too long (maximum is 1 character)",
          "other": "is too long (maximum is %{count} characters)"
        },
        "too_short": {
          "one": "is too short (minimum is 1 character)",
          "other": "is too short (minimum is %{count} characters)"
        },
        "total_file_size_not_between": "total file size must be between %{min} and %{max} (current size is %{total_file_size})",
        "total_file_size_not_equal_to": "total file size must be equal to %{exact} (current size is %{total_file_size})",
        "total_file_size_not_greater_than": "total file size must be greater than %{min} (current size is %{total_file_size})",
        "total_file_size_not_greater_than_or_equal_to": "total file size must be greater than or equal to %{min} (current size is %{total_file_size})",
        "total_file_size_not_less_than": "total file size must be less than %{max} (current size is %{total_file_size})",
        "total_file_size_not_less_than_or_equal_to": "total file size must be less than or equal to %{max} (current size is %{total_file_size})",
        "wrong_length": {
          "one": "is the wrong length (should be 1 character)",
          "other": "is the wrong length (should be %{count} characters)"
        }
      }
    },
    "external_api_webhook_logs": {
      "location": "Location",
      "operation": "Operation",
      "request_body": "Request body",
      "response_body": "Response body",
      "status": "Status",
      "timestamp": "Timestamp",
      "url": "URL"
    },
    "feeder_dosing_modes": {
      "activation_delay_ms": "Dosing time before blowing starts",
      "add_step": "Add step",
      "air_pressure": "Air pressure",
      "blower": "Air blowing",
      "blower_enabled": "Enable air blowing",
      "blowing_duration_off_ms": "Pause between blowing",
      "blowing_duration_on_ms": "Blowing duration",
      "column_ranges": {
        "high": "%{min}% and above",
        "low": "below %{max}%",
        "medium": "%{min}% to below %{max}%"
      },
      "comment_placeholder": "How did this feeder dosing mode perform?",
      "copy_from_mode": {
        "button": "Copy from existing mode",
        "load_error": "Failed to load feeder dosing modes",
        "loading": "Loading...",
        "no_sources": "No published feeder dosing modes to copy from",
        "overwrite_confirm": "Replace",
        "overwrite_text": "This will replace the fill boundaries, the fallback fill level, the fill-level parameters, the emergency settings and steps, the partial completion, the air blowing, go-back and pusher settings currently in the form with the values of the selected mode. The name and description stay. This cannot be undone until you save.",
        "overwrite_title": "Replace the parameters?",
        "search_placeholder": "Search feeder dosing modes...",
        "title": "Copy parameters from an existing feeder dosing mode"
      },
      "delete_draft_confirm_body": "Once deleted, its comments will be deleted too.",
      "description": "Description",
      "emergency": "Emergency dosing",
      "emergency_blower_setting_hint": "Replaces the standard air blowing while emergency dosing runs",
      "emergency_step": "Step %{number}",
      "emergency_steps": "Emergency steps",
      "enter_description": "Enter description",
      "enter_name": "Enter name",
      "feeder_dosing_mode": "Feeder dosing mode",
      "fill_boundaries": "Fill-level boundaries",
      "fill_boundaries_info": "The robot doses with the settings of the level that matches how full the container is: high from the high boundary up, medium from the medium boundary up to the high one, and low below the medium boundary. Fill is what is left in the container compared with the product's max container amount.",
      "go_back": "Go-back",
      "go_back_duration_ms": "Go-back duration",
      "go_back_enabled": "Enable go-back",
      "high_fill_min_percent": "High fill level from",
      "level_parameters": "Fill-level parameters",
      "levels": {
        "high": "High fill",
        "low": "Low fill",
        "medium": "Medium fill"
      },
      "low_fill_max_dosing_time_ms": "Max dosing time below 5 % fill",
      "max_acceptable_shortfall_percent": "Maximum acceptable shortfall",
      "max_attempts": "Max emergency attempts",
      "max_dosing_time_ms": "Max dosing time",
      "medium_fill_min_percent": "Medium fill level from",
      "name": "Name",
      "no_change_amount": "No-change amount",
      "no_change_max_time_ms": "No-change max time",
      "parameters": {
        "duration": "Duration",
        "duty_cycle": "Duty cycle",
        "fast_dosing": "Fast dosing",
        "frequency": "Frequency",
        "pressure": "Pressure",
        "slow_dosing": "Slow dosing"
      },
      "partial_completion": "Partial completion",
      "partial_completion_hint": "A standard or emergency dose this far short of the target still counts as complete; 0 requires the full amount",
      "placeholders": {
        "high_fill_min_percent": "e.g. 65",
        "medium_fill_min_percent": "e.g. 30"
      },
      "publish_confirm_locations": "Kitchens that receive the change:",
      "publish_confirm_no_locations": "No kitchen yet — these products are not loaded in any feeder at a kitchen with a robot",
      "publish_confirm_no_products": "This version is not assigned to any product yet, so no robot is updated.",
      "publish_confirm_products": "Publishing writes the new values to the robot for these products:",
      "pusher": "Pusher",
      "pusher_enabled": "Enable pusher",
      "pusher_hint": "Applies to standard and emergency dosing",
      "remove_step": "Remove step",
      "residual_delivery_amount": "Residual delivery amount",
      "save_error": "Save failed. Please try again or reload the page.",
      "save_failed": "Save failed. Please review the values.",
      "save_successful": "Save was successful.",
      "select_unknown_fill_fallback": "Select fill level",
      "standard_blower_setting_hint": "Applies to every fill level",
      "standard_dosing": "Standard dosing",
      "units": {
        "bar": "bar",
        "g": "g",
        "hz": "Hz",
        "percent": "%",
        "s": "s"
      },
      "unknown_fill_fallback": "Fallback level when fill is unknown",
      "unknown_fill_fallback_info": "The level the robot doses with when a container's fill can't be calculated: when the container has no starting amount or its product has no max container amount.",
      "validations": {
        "air_pressure": {
          "max": "Air pressure must be less than or equal to %{max}",
          "min": "Air pressure must be greater than or equal to %{min}",
          "required": "Air pressure is required"
        },
        "duty_cycle": {
          "max": "Duty cycle must be less than or equal to %{max}",
          "min": "Duty cycle must be greater than or equal to %{min}",
          "required": "Duty cycle is required"
        },
        "frequency": {
          "max": "Frequency must be less than or equal to %{max}",
          "min": "Frequency must be greater than or equal to %{min}",
          "required": "Frequency is required"
        },
        "low_fill_not_longer": "Must not be longer than the max dosing time",
        "medium_below_high": "Must be below the high fill boundary",
        "name": {
          "required": "Name is required"
        },
        "pressure": {
          "max": "Pressure must be less than or equal to %{max}",
          "min": "Pressure must be greater than or equal to %{min}",
          "required": "Pressure is required"
        },
        "required": "Required",
        "seconds_between": "Must be from %{min} to %{max} seconds",
        "whole_number_between": "Must be a whole number from %{min} to %{max}"
      }
    },
    "flash": {
      "actions": {
        "create": {
          "notice": "%{resource_name} was successfully created."
        },
        "destroy": {
          "alert": "%{resource_name} could not be destroyed.",
          "notice": "%{resource_name} was successfully destroyed."
        },
        "update": {
          "notice": "%{resource_name} was successfully updated."
        }
      }
    },
    "fractions": {
      "no_records_heading": "No fractions yet"
    },
    "global": {
      "all": "All",
      "confirm": "Are you sure?",
      "edit": "Edit",
      "new": "New"
    },
    "go_to": "Go to %{name}",
    "groups": {
      "no_records_heading": "No groups yet"
    },
    "helpers": {
      "page_entries_info": {
        "entry": {
          "one": "entry",
          "other": "entries",
          "zero": "entries"
        },
        "more_pages": {
          "display_entries": "Displaying %{entry_name} <b>%{first}&nbsp;-&nbsp;%{last}</b> of <b>%{total}</b> in total"
        },
        "one_page": {
          "display_entries": {
            "one": "Displaying <b>1</b> %{entry_name}",
            "other": "Displaying <b>all %{count}</b> %{entry_name}",
            "zero": "No %{entry_name} found"
          }
        }
      },
      "select": {
        "prompt": "Please select"
      },
      "submit": {
        "create": "Create %{model}",
        "submit": "Save %{model}",
        "update": "Update %{model}"
      }
    },
    "keep": "Keep",
    "locations": {
      "address": "Address",
      "ai_platform_enabled": "AI Platform enabled",
      "ai_platform_workspace_id": "AI Platform workspace ID",
      "back": "Back to list",
      "client_id": "Client ID",
      "client_secret": "Client secret",
      "create": "Create location",
      "created": {
        "success": "Location created"
      },
      "currency": "Currency",
      "date_format": "Date format",
      "enter_address": "Enter address",
      "enter_ai_platform_workspace_id": "Enter AI Platform workspace ID",
      "enter_ensor_connection_url": "Enter sensor connection URL",
      "enter_robot_certificate": "Enter (client) robot certificate (PEM format)",
      "enter_robot_connection_password": "Enter robot connection password",
      "enter_robot_connection_url": "Enter robot connection URL",
      "enter_robot_connection_username": "Enter robot connection username",
      "enter_robot_private_key": "Enter (client) robot private key (PEM format)",
      "enter_webhook_url": "Enter webhook URL",
      "enter_working_end_hour": "Enter working end hour",
      "enter_working_start_hour": "Enter working start hour",
      "kitchen_configuration": {
        "cooking_units": "Configure cooking units",
        "disable": "Disable",
        "disable_confirm": {
          "body": "Cooking unit(s) %{units} are currently in use. Meals already cooking in them will finish but will be marked for disposal — they will not be served and the customers will be compensated. Waiting meals will be reassigned to other cooking units.",
          "cancel": "Cancel",
          "confirm": "Disable anyway",
          "heading": "Disable cooking units in use?"
        },
        "enable": "Enable",
        "fixed_container_slots": "Configure fixed container slots",
        "heading": "Kitchen configuration",
        "locker_slots": "Configure locker slots",
        "mark_faulty": "Mark as faulty",
        "mark_not_faulty": "Mark as not faulty",
        "mobile_container_slots": "Configure mobile container slots",
        "plate_stands": "Configure plate stands",
        "robot_trays": "Configure trays",
        "show_alerts": "Show alerts",
        "travel_time": "Default Travel Time (seconds)",
        "validations": {
          "at_least_one_selected": "At least one %{slot_type} must be selected",
          "cooking_units_busy": "The following cooking units are currently in use: %{units}",
          "fixed_containers_busy": "The following fixed container slots have products inside: %{slots}",
          "fridge_slots": "At least one fridge and non-fridge slot must be selected",
          "fridge_slots_selected": "At least one fridge fixed container slot must be selected",
          "mobile_containers_busy": "The following mobile container slots have products inside: %{slots}",
          "non_fridge_slots_selected": "At least one non-fridge fixed container slot must be selected",
          "robot_trays": "At least one tray type must be selected",
          "robot_trays_selected": "At least one tray type must be selected",
          "slots": "At least one slot must be selected",
          "warning": "Warning!"
        }
      },
      "location": "Location",
      "locations": "Locations",
      "name": "Name",
      "no_records_heading": "No locations yet",
      "nonstop_working_hours": "Nonstop working hours",
      "required": "Required",
      "robot_certificate": "Robot (client) certificate",
      "robot_connection_password": "Robot connection password",
      "robot_connection_url": "Robot connection URL",
      "robot_connection_url_info": "In case robot connection URL is left empty, orders cannot be processed",
      "robot_connection_username": "Robot connection username",
      "robot_private_key": "Robot (client) private key",
      "save_failed": "Save failed. Please review the values.",
      "save_successful": "Save was successful.",
      "select_currency": "Select currency",
      "select_date_format": "Select date format",
      "select_location_to_continue": "Please select a kitchen to continue.",
      "select_temperature_scale": "Select temperature scale",
      "select_time_format": "Select time format",
      "select_timezone": "Select timezone",
      "select_weight_scale": "Select weight scale",
      "sensor_connection_url": "Sensor connection URL",
      "temperature_scale": "Temperature scale",
      "time_format": "Time format",
      "timezone": "Timezone",
      "update": "Update location",
      "updated": {
        "success": "Location updated"
      },
      "webhook_url": "Webhook URL",
      "weight_scale": "Weight scale",
      "working_end_hour": "Working end hour",
      "working_start_hour": "Working start hour"
    },
    "menu": {
      "edit_historical_menu_message": "Historical menus can't be deleted"
    },
    "menu_categories": {
      "no_records_heading": "No menu categories yet"
    },
    "microsoft_custom_vision": {
      "errors": {
        "body_not_image": "Request body must contain a binary image",
        "container_not_found": "Given product container was not found",
        "missing": "%{missing_object} is missing in the image"
      }
    },
    "modal": {
      "edit": "Edit",
      "new": "Add new"
    },
    "move_mode_steps": {
      "add": "Add Move Mode Step",
      "duration": "Duration",
      "duration_type": "Duration type",
      "move_mode_step": "Move mode step",
      "remove": "Remove",
      "select_submove": "Select submove",
      "title": "Move Mode Steps",
      "validations": {
        "duration": "Duration is required",
        "duration_type": "Duration type is required"
      }
    },
    "move_mode_test_cases": {
      "add_step": "+ Add step",
      "amount": "Amount (g)",
      "cancel": "Cancel",
      "cooker": "Cooker",
      "cooker_option": "Cooker %{number}",
      "delete": "Delete",
      "delete_confirm": "Delete this test case?",
      "duration_seconds": "Seconds",
      "edit": "Edit",
      "edit_title": "Edit test case",
      "finish_session": "Finish testing",
      "fixed_prefix": "Start boiler → Place cup → Add oil",
      "fixed_suffix": "Unload (%{mode}) → Wash → Pick cup → Deposit to locker",
      "in_stock": "%{amount} g in stock",
      "incomplete_steps": "Fill in before saving — %{fields}",
      "ingredient_step_required": "at least one Add product or Add sauce step",
      "loading": "Loading…",
      "name": "Name",
      "name_placeholder": "e.g. Rice stirring tuning",
      "new_test_case": "+ New test case",
      "new_title": "New test case",
      "no_test_cases": "No test cases yet",
      "no_test_cases_subtext": "Compose one to start tuning move modes on this kitchen",
      "notes": "Notes",
      "operations": {
        "add_product": "Add product",
        "add_sauce": "Add sauce",
        "cook": "Cook",
        "set_stove_level": "Set stove level"
      },
      "request_failed": "Something went wrong — please try again",
      "run": "Run",
      "run_requires_session": "Start a testing session to run test cases",
      "run_started": "Test meal queued — order #%{id}",
      "save": "Save test case",
      "select_location": "Select a kitchen",
      "select_move_mode": "Select move mode",
      "select_product": "Select product",
      "session_active": "Customer orders are paused at this kitchen until you finish testing",
      "session_active_badge": "Testing session active",
      "session_none_badge": "No testing session",
      "session_other": "Finish it before testing move modes here",
      "session_other_badge": "%{type} session %{state}",
      "start_session": "Start testing session",
      "step_number": "Step %{number}",
      "steps": "Steps",
      "stove_level": "Level",
      "title": "Testing",
      "title_prefix": "Move modes",
      "unavailable_selection": "No longer available at this kitchen — pick again: %{fields}",
      "unload_with": "Unload with",
      "what_will_run": "What will run"
    },
    "move_modes": {
      "description": "Description",
      "move_mode": "Move mode",
      "move_mode_type": "Move mode type",
      "move_mode_types": {
        "cooking_mode": "Cooking mode",
        "unload_mode": "Unload mode"
      },
      "move_modes": "Move modes",
      "name": "Name",
      "organizations": "Organizations",
      "save_failed": "Save failed. Please review the values.",
      "save_successful": "Save was successful.",
      "usage": {
        "archived_badge": "Archived versions only",
        "archived_only_notice": "No live recipe uses this move mode any more. It still cannot be deleted while archived versions reference it.",
        "column_tooltip": "Recipes using this move mode / Meals prepared from them in the last 30 days",
        "empty": "This move mode is not used in any recipe.",
        "prepared_badge": "Prepared %{times}× (30d)",
        "prepared_count": {
          "one": "%{count} meal prepared in the last 30 days",
          "other": "%{count} meals prepared in the last 30 days"
        },
        "recipe_count": {
          "one": "%{count} recipe total",
          "other": "%{count} recipes total"
        },
        "summary": "%{recipes} · %{meals}",
        "title": "Usage"
      },
      "validations": {
        "description": "Description is required",
        "name": "Name is required"
      }
    },
    "navbar": {
      "admin": {
        "advanced": "Advanced",
        "alergens": "Product alergens",
        "audit_logs": "Audit Logs",
        "boiler_batch_snapshots": "Boiler Batch Snapshots",
        "business_errors": "Alert Automation",
        "command_history": "Command history",
        "configure_commands": "Configure commands",
        "cooking_modes": "Cooking modes",
        "currencies": "Currencies",
        "custom_vision": "Custom Vision",
        "dosing_mode_configurator": "Dosing mode configurator",
        "external_api_webhook_logs": "Webhook logs",
        "feeder_dosing_modes": "Feeder dosing modes",
        "fractions": "Product fractions",
        "groups": "Product groups",
        "heat_energy_readings": "Heat Energy Readings",
        "locations": "Locations",
        "main_batch_snapshots": "Main Batch Snapshots",
        "management": "Management",
        "menu_categories": "Menu categories",
        "monitor": "Monitoring",
        "move_method_configurator": "Move method configurator",
        "move_mode_test_cases": "Move mode testing",
        "move_modes": "Move modes",
        "organizations": "Organizations",
        "robot_sensors": "Sensors",
        "roles": "Roles",
        "sauce_dosing_modes": "Sauce dosing modes",
        "scheduler_run_reports": "Scheduler logs",
        "sensor_logs": "Sensor Logs",
        "sentry_alerts": "Business Alerts",
        "servo_move_steps": "Servo move steps",
        "settings": "Settings",
        "sms_notifications": "SMS Notifications",
        "tenant_admins": "Organization Admins",
        "units": "Product units",
        "users": "Users",
        "vouchers": "Vouchers",
        "web_request_logs": "API logs"
      },
      "user": {
        "imperial_units": "Show imperial units",
        "location_units": "Show location units",
        "metric_units": "Show metric units",
        "sign_out": "Sign out",
        "signed_in_as_user": "You are signed in as user %{first_name} %{last_name}"
      }
    },
    "next": "Next",
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "negative_format": "-%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Billion",
            "million": "Million",
            "quadrillion": "Quadrillion",
            "thousand": "Thousand",
            "trillion": "Trillion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB",
            "zb": "ZB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "open": "Open",
    "order": {
      "cancel_manual_payment": {
        "success": "Manual payment canceled"
      },
      "cancel_manually_paid_payment": {
        "success": "Payment successfully canceled"
      },
      "confirm_manual_payment": {
        "error": "Manual payment not approved, %{message}",
        "success": "Manual payment approved"
      },
      "create_order": {
        "success": "Order successfully created"
      },
      "created_message": "Order successfully created!",
      "customer_cancel": {
        "button": "Cancel order",
        "confirmation": "Cancel this order? You will get a free-meal voucher for your next order, or you can ask for a refund at the Atrium cafe during its working hours.",
        "in_progress": "Canceling…"
      },
      "errors": {
        "could_not_obtain_lock": "Could not obtain stock_allocator_lock",
        "disposal_issue": "There was an issue preparing your meal. Go to Atrium cafe for help",
        "generic": "Something went wrong. Please try again later.",
        "invalid_payment_intent": "Invalid payment intent!",
        "lockers_busy": "All lockers busy",
        "not_accepting_orders": "We're not accepting orders right now. Please try again later.",
        "not_cancellable": "This order can no longer be canceled.",
        "service_session_in_progress": "Cannot make orders while service session is in progress!",
        "session_expired": "Your session has expired. Please refresh the page and try again",
        "unexpected_payment_intent_state": "Unexpected payment intent state!"
      },
      "mark_as_delivered": {
        "success": "Order marked as delivered"
      },
      "no_active_records_heading": "No active orders yet",
      "no_active_records_subtext": "Active orders will appear in Order Queue.",
      "no_history_records_heading": "Order history is empty"
    },
    "order_providers": {
      "activate_api_key": "Activate API key",
      "activate_api_key_required": "Activate API key is required",
      "activate_base_url": "Activate API base URL",
      "activate_base_url_required": "Activate API base URL is required",
      "activate_location_number": "Activate location number",
      "activate_location_number_required": "Activate location number is required",
      "auth_services_base_url": "Auth services base URL",
      "auth_services_base_url_required": "Auth services base URL is required",
      "base_url": "API base URL",
      "base_url_required": "API base URL is required",
      "client_id": "Client ID",
      "client_id_required": "Client ID is required",
      "company_id": "Company ID",
      "company_id_required": "Company ID is required",
      "infor_api_key": "Infor API key",
      "infor_api_key_required": "Infor API key is required",
      "location_ref": "Location identifier",
      "location_ref_required": "Location identifier is required",
      "menu_item_screen_id": "Menu item screen ID",
      "menu_item_screen_id_required": "Menu item screen ID is required",
      "menu_item_subcategory_id": "Menu item subcategory ID",
      "menu_item_subcategory_id_required": "Menu item subcategory ID is required",
      "menu_item_top_category_id": "Menu item top category ID",
      "menu_item_top_category_id_required": "Menu item top category ID is required",
      "modifier_subcategory_id": "Modifier subcategory ID",
      "modifier_subcategory_id_required": "Modifier subcategory ID is required",
      "modifier_top_category_id": "Modifier top category ID",
      "modifier_top_category_id_required": "Modifier top category ID is required",
      "not_destroyable": "Cannot remove order provider with already existing orders",
      "organization_name": "Organization identifier",
      "organization_name_required": "Organization identifier is required",
      "password": "Password",
      "password_required": "Password is required",
      "revenue_center_ref": "Revenue center identifier",
      "revenue_center_ref_required": "Revenue center identifier is required",
      "robo_api_key": "Robo API key",
      "robo_api_key_configured": "Robo API key configured",
      "robo_api_key_not_configured": "Robo API key not configured",
      "select_order_providers": "Select order providers",
      "set_up": "Order provider - %{provider_type}",
      "store_id": "Store ID",
      "store_id_required": "Store ID is required",
      "username": "Username",
      "username_required": "Username is required"
    },
    "orders": {
      "actions": "Actions",
      "asap": "ASAP",
      "cancel": "Cancel",
      "cancel_order": "Cancel Order",
      "cancel_paid_order": "Cancel paid order",
      "cancel_queue": "Cancel Queue",
      "closed_for_orders": "Closed for orders",
      "confirm_mark_for_disposal": "This meal will not be served and the customer will be issued a voucher. Are you sure?",
      "end_time": "End time",
      "external_id": "External ID",
      "filters": {
        "external_id": "External ID",
        "order_id": "Order number",
        "phone_number": "Phone number",
        "queued_order_id": "Meal ID",
        "received": "Order received",
        "recipe_name": "Recipe name",
        "status": "Status"
      },
      "heat_energy_in_pan": "Heat energy in pan",
      "in_locker": "In locker",
      "issues": {
        "external": "External order ID",
        "fail_reasons": {
          "customer_phone_invalid": "Invalid customer phone",
          "insufficient_plate_amount": "Not enough bowls",
          "insufficient_product_amount": "Ingredient out of stock",
          "missing_customer_info": "Missing customer info",
          "order_failed": "Import failed",
          "orders_stopped": "Order intake was stopped",
          "unrecognized_product_id": "Unrecognized ingredient",
          "unrecognized_recipe_id": "Unrecognized menu item"
        },
        "issue": "Issue",
        "meal_id": "Meal ID",
        "meal_status": "Meal status",
        "no_records_heading": "No order issues",
        "order_number": "Order number",
        "product": "Product",
        "recent": "Reported in the last 24 hours",
        "recipe": "Recipe",
        "tab_alert": {
          "one": "%{count} issue in the last 24 hours",
          "other": "%{count} issues in the last 24 hours"
        },
        "types": {
          "cooker_disabled": "Cooker disabled while meal was cooking",
          "cooker_fault": "Cooker fault",
          "critical_ingredient_failed": "Critical ingredient failed to dose",
          "critical_ingredient_partially_dosed": "Critical ingredient partially dosed",
          "cup_dropped": "Cup dropped",
          "failed_order": "Order rejected at intake",
          "manual_disposal": "Meal marked for disposal by staff",
          "meal_weight_too_low": "Meal weight too low",
          "non_critical_ingredient_out_of_stock": "Ingredient skipped (out of stock)",
          "non_critical_ingredient_skipped": "Ingredient skipped (failed to dose)",
          "orders_stopped": "Order intake was stopped",
          "robot_reset": "Meal discarded by robot reset"
        },
        "when": "When"
      },
      "last_updated": "Last updated %{seconds}s ago",
      "locker": "Locker",
      "mark_as_paid": "Mark as paid",
      "mark_for_disposal": "Dispose meal & issue voucher",
      "meal": "Meal",
      "meal_statuses": {
        "canceled": "canceled",
        "cooking": "preparing",
        "disposed": "disposed",
        "failed": "failed",
        "marked_for_disposal": "marked for disposal",
        "picked_up": "picked up",
        "processing": "processing",
        "ready_for_pickup": "ready for pickup",
        "received": "received",
        "written_to_robot": "written to robot"
      },
      "measured_meal_weight": "Weight at deposit",
      "open_locker": "Open Locker #%{number}",
      "order": "Order",
      "order_history": "Order History",
      "order_issues": "Order Issues",
      "order_queue": "Order Queue",
      "order_received": "Order received",
      "order_scheduling_disabled": "Order scheduling disabled",
      "order_status": "Status",
      "order_status_tab": "Order status",
      "phone": "Phone",
      "planned_end_time": "Planned end time",
      "planned_preparation_start": "Planned start time",
      "prioritize": "Prioritize",
      "priority": "Priority",
      "provider_external_id": "%{provider} ID",
      "refresh": "Refresh",
      "restart_queue": "Restart Queue",
      "robot_restarted": "Robot has been restarted",
      "see_details": "See details",
      "start_time": "Start time",
      "technical_order": "Technical order",
      "time_in_locker": "time in locker",
      "time_labels": {
        "actual": "Actual",
        "original": "Original estimate",
        "planned": "Planned"
      },
      "type": {
        "both": "Meal + Technical",
        "meal": "Meal",
        "technical": "Technical"
      },
      "unit": "Cooker",
      "unprioritize": "Remove priority",
      "update_failed": "Update failed — retrying",
      "updating": "Updating…",
      "voucher": {
        "badge": "voucher issued",
        "issued_by_customer": "Issued automatically after the customer canceled",
        "issued_by_staff": "Issued manually by staff",
        "issued_by_system": "Issued automatically by the system",
        "issued_by_user": "Issued manually by %{name}",
        "statuses": {
          "expired": "expired",
          "invalidated": "invalidated",
          "redeemed": "redeemed"
        }
      }
    },
    "organizations": {
      "address": "Address",
      "code": "Abbreviation",
      "created": {
        "success": "Organization created"
      },
      "name": "Organization name",
      "organization": "Organization",
      "organizations": "Organizations",
      "save_failed": "Save failed. Please review the values.",
      "save_successful": "Save was successful.",
      "select_organization_to_continue": "Please select an organization to continue.",
      "updated": {
        "success": "Organization updated"
      },
      "validations": {
        "code": "Code is required",
        "name": "Name is required"
      }
    },
    "pages": {
      "controls": "Control",
      "menu": "Menu",
      "orders": "Orders",
      "organizations": "Organizations",
      "products": "Catalogue",
      "recipes": "Recipes",
      "reports": "Reports",
      "stocks": "Stock",
      "tenant_admins": "Organization Admins"
    },
    "previous": "Previous",
    "proceed": "Proceed",
    "product": {
      "alergens": "Alergens",
      "alert": "Alert",
      "conversion_to_fluid_ounces": "Conversion to fluid ounces",
      "conversion_to_liters": "Conversion to liters",
      "dosing_time": "Dosing time (seconds/100g)",
      "dosing_weight_step": "Slow dosing amount",
      "dosing_weight_step_info": "When this much is left to reach the requested amount, the robot switches from fast to slow dosing for the rest. A portion smaller than this is dosed slowly from the start. Example: 10 g on a 100 g portion means fast dosing up to 90 g, then slow dosing for the last 10 g.",
      "feeder_dosing_mode": "Dosing mode",
      "feeder_subtype": "Feeder subtype",
      "feeder_subtypes": {
        "fridge": "Refrigerator",
        "standard": "Container"
      },
      "feeder_type": "Feeder type",
      "fraction": "Fraction",
      "is_modifier": "Modifier",
      "kcal": "kcal / 100 g",
      "kj": "kj / 100 g",
      "max_container_amount": "Max container amount",
      "no_records_heading": "No products yet",
      "notes": "Notes",
      "processing_loss": "Processing loss",
      "product": "Product",
      "product_is_modifier": "Product is a modifier",
      "product_is_not_modifier": "Product is not a modifier",
      "product_name": "Product name",
      "sauce_dosing_mode": "Dosing mode",
      "unit": "Unit",
      "validations": {
        "dosing_weight_step": {
          "greater_than": "Slow dosing amount must be greater than 0",
          "required": "Slow dosing amount is required"
        },
        "feeder_dosing_mode": {
          "required": "Dosing mode is required"
        },
        "is_modifier": {
          "required": "Select whether the product is a modifier"
        },
        "location": {
          "required": "Category is required"
        },
        "sauce_dosing_mode": {
          "required": "Dosing mode is required"
        }
      }
    },
    "product_container": {
      "replace": "Replace",
      "replace_container": "Replace container"
    },
    "recaptcha": {
      "errors": {
        "recaptcha_unreachable": "Oops, we failed to validate your reCAPTCHA response. Please try again.",
        "verification_failed": "We couldn't verify that you're not a robot. Please refresh the page and try again."
      }
    },
    "recipes": {
      "actions": {
        "clone_recipe": "Copy to new recipe",
        "create_new_version": "Create new version",
        "edit": "Edit"
      },
      "all_recipes": "All Recipes",
      "archive": {
        "already_archived": "Recipe is already archived",
        "button": "Archive",
        "failure": "Could not archive recipe",
        "success": "Recipe archived"
      },
      "batch": "Batch",
      "batch_recipes": "Batch recipes",
      "bowl": "Bowl",
      "bowl_batch": "Bowl + Batch",
      "bowl_recipes": "Bowl recipes",
      "bowls": "bowls",
      "change_recipe_type": {
        "text_batch": "You are about to change recipe type to \"Batch\".",
        "text_bowl": "You are about to change recipe type to \"Bowl\".",
        "text_clear": "This will clear \"Add solid toppings\" and \"Add liquid toppings\" steps.",
        "title": "Warning"
      },
      "clone": {
        "success": "Recipe cloned"
      },
      "copy_from_recipe": {
        "button": "Copy from existing recipe",
        "fetch_error": "Failed to load selected recipe",
        "load_error": "Failed to load recipes",
        "loading": "Loading...",
        "no_recipes": "No recipes found",
        "overwrite_confirm": "Replace",
        "overwrite_text": "This will replace all steps currently in the form with steps from the selected recipe. This cannot be undone until you save.",
        "overwrite_title": "Replace existing steps?",
        "search_placeholder": "Search recipes...",
        "title": "Copy steps from an existing recipe"
      },
      "delete_draft": {
        "button": "Delete draft",
        "failure": "Could not delete recipe",
        "has_orders": "Recipes with orders cannot be deleted",
        "not_a_draft": "Only draft recipes can be deleted"
      },
      "filters": {
        "default_statuses": "Published + Draft",
        "status": "Status"
      },
      "load_error": "Failed to load recipes",
      "new_recipe": "New Recipe",
      "no_category_items": "There are no items in this category",
      "no_records_heading": "No recipes yet",
      "processing_loss_info": "Percentage of weight that the meal is expected to lose while cooking. The robot weighs the cup when picking it up from the cooker and disposes the meal if it weighs less than the recipe's ingredient weight minus this percentage. Example: with 30%, a meal whose ingredients add up to 1000 g is served only if it weighs at least 700 g (70%).",
      "publish": {
        "already_a_draft": "This recipe is already a draft",
        "button": "Save and publish",
        "draft_already_exists": "A draft version of this recipe already exists",
        "draft_created": "Draft recipe created",
        "failure": "Could not publish recipe",
        "not_a_draft": "Only draft recipes can be published",
        "published_read_only_notice": "Published recipes are read-only. Create a new version to make changes.",
        "success": "Recipe published"
      },
      "recipe_page": "Recipe spec sheet",
      "recipe_products": {
        "amount": "Amount",
        "cook_time": "Cook time",
        "critical_ingredient": "Product marked as critical - click to unmark",
        "heading": "Products",
        "lock": "The product can be marked as default (locked) or optional (unlocked) in the meal for the end user",
        "lock_disabled": "This product is mandatory and cannot be unlocked as it is not marked as modifier",
        "non_critical_ingredient": "Product marked as non-critical - click to mark as critical",
        "subtext": "Drag and drop products, you can also drag and drop on top of each other to make group"
      },
      "recipe_tasks": {
        "cooking_mode": {
          "cooking_mode_description": {
            "angle_position": "Angle position",
            "mixer_speed": "Mixer speed",
            "move_method": "Move method",
            "rotation_speed": "Rotation speed"
          },
          "select_placeholder": "Select"
        },
        "heading": "Actions",
        "keep_heat": "Keep heat",
        "operations": {
          "set_cooking_mode": "Cooking mode",
          "set_stove_level": "Heat level",
          "unload_boiler": "Unload",
          "wash_tray": "Wash tray"
        },
        "set_heat": "Set heat",
        "steps": {
          "add_liquid_toppings": "Add liquid toppings",
          "add_solid_toppings": "Add solid toppings",
          "boiler_tasks": "Drag & drop products or operations here",
          "cooking_module": "Cooking module",
          "liquid_topping_tasks": "Drag & drop sauces directly into bowl",
          "non_cooked_base": "Add non-cooked base products",
          "non_cooked_base_tasks": "Drag & drop solid products into bottom of bowl",
          "solid_topping_tasks": "Drag & drop solid products directly into bowl"
        },
        "subtext": "Drag and drop actions into: Step 2: Cooking module",
        "unload_mode": {
          "select_placeholder": "Select unload mode"
        }
      },
      "statuses": {
        "archived": "Archived",
        "draft": "Draft",
        "published": "Published"
      },
      "type": "Type",
      "version_select": {
        "label": "Version"
      },
      "version_switch": {
        "text": "You have unsaved changes. They will be lost if you switch to another version."
      }
    },
    "remove": "Remove",
    "replenishment": {
      "banner": {
        "edit_order": "Edit order",
        "finish_order": "Finish Replenishment order.",
        "order_in_progress": "Replenishment order is in progress, you can't make any edits until the order is completed",
        "order_not_finished": "You haven't finished your Replenishment order. ",
        "order_placed": "You have placed a replenishment order. You can't place a new order while you have an active one. "
      },
      "bowls": {
        "already_on_order": "An active order already brings %{amount} bowls to this stand, so only the space left after those can be refilled",
        "bowl_stand": "Bowl stand #%{slotNumber}",
        "bowls_header": "Bowls stand #%{slotNumber} refill",
        "bowls_message": "%{amount} pcs added to your basket"
      },
      "errors": {
        "active_session_error": "Cannot place new replenishment orders during active replenishment session"
      },
      "export": {
        "bowls": "Bowls",
        "delivery_date": "Delivery date: %{deliveryDate}",
        "download": "Download",
        "liquid_ingredients": "Liquid ingredients",
        "oil": "Oil",
        "print": "Print",
        "product_change": "Product change",
        "refill": "Refill",
        "replenishment_order": "Replenishment order #%{orderId}",
        "solid_ingredients": "Solid ingredients"
      },
      "oil": {
        "oil_message": "Oil replenishment added to your basket",
        "oil_tank": "Oil tank",
        "refill_tank": "Refill oil tank"
      },
      "order_placed_modal": {
        "date": "Replenishment scheduled: ",
        "location": "Location: "
      },
      "order_table": {
        "action": "Action",
        "amount": "Amount",
        "container_slot_number": "Container slot number",
        "new_product": "New product",
        "previous_product": "Previous product",
        "replenishment_type": "Replenishment type"
      },
      "remove_item_modal_text": "Remove this item from your order?",
      "replenishment_modal": {
        "amount": "Amount",
        "basket_success": "Successfully added to your basket",
        "container_header_product_change": "Container #%{slotNumber} product change",
        "container_header_refill": "Container #%{slotNumber} refill",
        "continue": "Continue",
        "empty": "Empty",
        "empty_container": "Empty container",
        "expiration_date": "Expiration date",
        "go_to_basket": "Go to basket",
        "notes": "Notes",
        "product_change": "Product change",
        "product_container": "Product container #%{slotNumber}",
        "refill_product": "Refill product",
        "replace_container": "Replace container #%{slotNumber}",
        "replace_product": "Replace product",
        "save_changes": "Save changes",
        "to_be_updated": "To be updated after replenishment",
        "to_refill": "to refill"
      },
      "sidebar": {
        "basket_empty": "Basket is empty",
        "bowls": "Bowls",
        "cancel_order_btn": "Cancel order",
        "close_btn": "Close",
        "empty_container": "Empty container",
        "heading": "Your order",
        "history": {
          "active_orders": "Active orders",
          "bowls": "Bowls",
          "cancel_item_modal_text": "Cancel replenishment of this product?",
          "cancel_replenishment": "Cancel replenishment",
          "cart": "Cart",
          "item": "item",
          "items": "items",
          "my_orders": "My orders",
          "no_active_orders": "No active orders",
          "no_past_orders": "No past orders",
          "oil": "Oil",
          "order_name": "Order #%{orderId}",
          "orders_history": "Orders history",
          "planned_delivery": "Planned delivery:",
          "replenishment_order_name": "Replenishment order #%{orderId}",
          "show_more": "Show more",
          "state_canceled": "Canceled",
          "state_closed": "Closed",
          "state_completed": "Completed %{deliveryDate}",
          "state_draft": "Draft",
          "state_editing": "Editing",
          "state_open": "Open",
          "state_sent": "Sent",
          "status": "Status:"
        },
        "menu_modal": {
          "dishes_with": "Dishes with",
          "no_recipes": "No recipes in menu",
          "no_recipes_with_ingredient": "No recipes with this ingredient in the menu",
          "save_menu": "Save Menu",
          "system": "System",
          "title": "Menu for"
        },
        "oil": "Oil",
        "order_placed_message": "Your order #%{orderId} is placed",
        "order_sent_editing_message": "You have already sent order. You have to enter editing mode first",
        "order_updated_message": "Successfully updated order #%{orderId}",
        "place_order_btn": "Place order",
        "product_change": "Product change",
        "refill": "Refill",
        "replenish_date": "Replenish date",
        "replenishment_type": "Replenishment type",
        "replenishment_types": {
          "auto": "Auto",
          "manual": "Manual"
        },
        "update_order_btn": "Update order",
        "view_dishes_with_ingredient": "View dishes with this ingredient",
        "view_full_menu": "View full menu for"
      }
    },
    "reset": "Reset",
    "roles": {
      "no_records_heading": "No roles yet"
    },
    "sauce_dosing_modes": {
      "comment_placeholder": "How did this sauce dosing mode perform?",
      "copy_from_mode": {
        "button": "Copy from existing mode",
        "load_error": "Failed to load sauce dosing modes",
        "loading": "Loading...",
        "no_sources": "No published sauce dosing modes to copy from",
        "overwrite_confirm": "Replace",
        "overwrite_text": "This will replace the fill boundaries, the fallback fill level, the level parameters and the maximum acceptable shortfall currently in the form with the values of the selected mode. The name and description stay. This cannot be undone until you save.",
        "overwrite_title": "Replace the parameters?",
        "search_placeholder": "Search sauce dosing modes...",
        "title": "Copy parameters from an existing sauce dosing mode"
      },
      "delete_draft_confirm_body": "Once deleted, its comments will be deleted too.",
      "description": "Description",
      "emergency_dosing": "Emergency dosing",
      "emergency_strategies": {
        "hold_until_slow_mode": "Hold until slow mode",
        "hold_until_stop_advance": "Hold until stop advance",
        "temporary_boost": "Temporary boost"
      },
      "enter_description": "Enter description",
      "enter_name": "Enter name",
      "fill_boundaries": "Fill-level boundaries",
      "fill_boundaries_info": "The robot doses with the settings of the level that matches how full the container is: high from the high boundary up, medium from the medium boundary up to the high one, and low below the medium boundary. Fill is what is left in the container compared with the product's max container amount.",
      "fill_levels": {
        "high": "High fill",
        "low": "Low fill",
        "medium": "Medium fill"
      },
      "fill_ranges": {
        "high": "%{from}% and above",
        "low": "below %{to}%",
        "medium": "%{from}% to below %{to}%"
      },
      "high_fill_min_percent": "High / medium boundary",
      "level_parameters": "Fill-level parameters",
      "level_params": {
        "emergency_enabled": "Emergency dosing enabled",
        "emergency_pressure": "Emergency pressure",
        "emergency_residual_delivery_amount": "Emergency residual delivery amount",
        "emergency_strategy": "Strategy",
        "fast_pressure": "Fast pressure",
        "max_dosing_duration_ms": "Maximum dosing time",
        "max_emergency_duration_ms": "Maximum emergency duration",
        "no_change_amount": "No-change amount",
        "no_change_max_time_ms": "No-change max time",
        "slow_pressure": "Slow pressure",
        "stop_advance_grams": "Stop advance"
      },
      "level_units": {
        "emergency_pressure": "bar",
        "emergency_residual_delivery_amount": "g",
        "fast_pressure": "bar",
        "max_dosing_duration_ms": "ms",
        "max_emergency_duration_ms": "ms",
        "no_change_amount": "g",
        "no_change_max_time_ms": "ms",
        "slow_pressure": "bar",
        "stop_advance_grams": "g"
      },
      "max_acceptable_shortfall_percent": "Maximum acceptable shortfall",
      "medium_fill_min_percent": "Medium / low boundary",
      "name": "Name",
      "partial_completion": "Partial completion",
      "partial_completion_hint": "A standard or emergency dose this far short of the target still counts as complete; 0 requires the full amount",
      "placeholders": {
        "fast_pressure": "e.g. 0.70",
        "high_fill_min_percent": "e.g. 65",
        "medium_fill_min_percent": "e.g. 30",
        "select_strategy": "Select strategy",
        "slow_pressure": "e.g. 0.20"
      },
      "publish_confirm_locations": "Kitchens that receive the change:",
      "publish_confirm_no_locations": "No kitchen yet — these products are not loaded in any container at a kitchen with a robot",
      "publish_confirm_no_products": "This version is not assigned to any product yet, so no robot is updated.",
      "publish_confirm_products": "Publishing writes the new values to the robot for these products:",
      "sauce_dosing_mode": "Sauce dosing mode",
      "save_failed": "Save failed. Please review the values.",
      "save_successful": "Save was successful.",
      "select_unknown_fill_fallback": "Select fill level",
      "unknown_fill_fallback": "Fallback level when fill is unknown",
      "unknown_fill_fallback_info": "The level the robot doses with when a container's fill can't be calculated: when the container has no starting amount or its product has no max container amount.",
      "validations": {
        "integer": "%{field} must be a whole number",
        "max": "%{field} must be less than or equal to %{max}",
        "medium_below_high": "Must be below the high fill boundary",
        "min": "%{field} must be greater than or equal to %{min}",
        "required": "%{field} is required",
        "unknown_fill_fallback": "Fallback fill level is required"
      }
    },
    "save": "Save",
    "save_success": "Record saved successfully",
    "saved_successfully": "Saved successfully",
    "scheduler_run_reports": {
      "created_at": "Created at",
      "ended_at": "Ended at",
      "error_code": "Error code",
      "failure_reason": "Failure reason",
      "from": "From",
      "started_at": "Started at",
      "state": "State",
      "to": "To"
    },
    "search": "Search...",
    "service_tasks": {
      "active": "Active",
      "days_of_week": "Days of week",
      "description": "Description",
      "enter_description": "Enter description (e.g. instructions for the technician)",
      "enter_title": "Enter title",
      "interval": "Interval",
      "recurrence_type": "Recurrence type",
      "recurrence_types": {
        "day": "Day",
        "days_of_week": "Days of week",
        "month": "Month",
        "perform_once": "Perform once",
        "week": "Week",
        "year": "Year"
      },
      "save_failed": "Save failed. Please review the values.",
      "save_successful": "Save was successful.",
      "service_task": "Service task",
      "start_date": "Start date",
      "title": "Title",
      "validations": {
        "days_of_week": "Select at least one day of the week",
        "interval": "Interval must be at least 1",
        "title": "Title is required"
      },
      "weekdays": {
        "friday": "Friday",
        "monday": "Monday",
        "saturday": "Saturday",
        "sunday": "Sunday",
        "thursday": "Thursday",
        "tuesday": "Tuesday",
        "wednesday": "Wednesday"
      }
    },
    "servo_move_steps": {
      "ai_suggestions": {
        "clamped_notice": "Some requested values were capped to the safe limits.",
        "discard": "Discard",
        "failed": "Could not generate a suggestion",
        "generate": "Generate suggestion",
        "generating": "Generating…",
        "moves_count": "Moves: %{before} → %{after}, proposed values:",
        "open_draft": "Open draft v%{version}",
        "placeholder": "Describe the change, e.g. \"make it faster but keep the descent gentle\"",
        "refine_placeholder": "Refine the proposal, e.g. \"a little less\"",
        "still_processing": "The assistant is taking longer than expected. The draft will appear in the versions list once it is done — reload the page later.",
        "title": "AI suggestions"
      },
      "comment_placeholder": "How did this servo move step perform?",
      "copy_from_step": {
        "button": "Copy from existing step",
        "load_error": "Failed to load servo move steps",
        "loading": "Loading...",
        "moves": "%{count} moves",
        "no_sources": "No published servo move steps of this type to copy from",
        "overwrite_confirm": "Replace",
        "overwrite_text": "This will replace the moves currently in the form with the moves of the selected step. The name stays. This cannot be undone until you save.",
        "overwrite_title": "Replace the moves?",
        "search_placeholder": "Search servo move steps...",
        "title": "Copy moves from an existing servo move step"
      },
      "delete_draft_confirm_body": "Once deleted, its comments will be deleted too.",
      "delete_draft_confirm_title": "Delete this draft?",
      "move_step_type": "Move step type",
      "move_step_types": {
        "cooking_mode": "Cooking mode",
        "unload_mode": "Unload mode"
      },
      "name": "Name",
      "not_synced": "Not synced",
      "number_of_moves": "Number of servo moves",
      "publish_confirm_locations": "Kitchens that will receive the change on their next sync:",
      "publish_confirm_no_locations": "No kitchen yet — these move modes are not synced to any organization",
      "publish_confirm_no_modes": "This version is not used by any move mode yet.",
      "publish_confirm_used_bold": "next time you execute \"sync with robot\"",
      "publish_confirm_used_prefix": "Publishing will update these move modes on robot ",
      "save_failed": "Save failed. Please review the values.",
      "save_successful": "Save was successful.",
      "servo_move_step": "Servo move step",
      "synced": "Synced",
      "usage": {
        "column_tooltip": "Move modes this servo move step is part of / Meals prepared through them in the last 30 days",
        "empty": "This servo move step is not part of any move mode.",
        "move_mode_count": {
          "one": "Part of %{count} Move Mode",
          "other": "Part of %{count} Move Modes"
        },
        "move_mode_counts": "%{recipes} · %{prepared}",
        "prepared_count": {
          "one": "%{count} meal prepared in the last 30 days",
          "other": "%{count} meals prepared in the last 30 days"
        },
        "row_prepared_count": {
          "one": "%{count} meal prepared (30d)",
          "other": "%{count} meals prepared (30d)"
        },
        "row_recipe_count": {
          "one": "%{count} recipe",
          "other": "%{count} recipes"
        },
        "summary": "%{move_modes} · %{meals}",
        "title": "Usage"
      },
      "used_by_move_modes": "Used by move modes",
      "validations": {
        "max_number_of_moves": "At most 4 servo moves are allowed",
        "min_number_of_moves": "At least one servo move is required",
        "name": "Name is required",
        "number_of_moves": "Number of servo moves is required"
      }
    },
    "servo_moves": {
      "acceleration": "Acceleration (m/s²)",
      "add": "Add Servo Move",
      "deceleration": "Deceleration (m/s²)",
      "move": "Servo move",
      "pause_time": "Pause time (ms)",
      "position": "Position (mm)",
      "remove": "Remove",
      "title": "Servo moves",
      "validations": {
        "acceleration": {
          "max": "Acceleration must be less than or equal to %{max}",
          "min": "Acceleration must be greater than or equal to %{min}",
          "required": "Acceleration is required"
        },
        "deceleration": {
          "max": "Deceleration must be less than or equal to %{max}",
          "min": "Deceleration must be greater than or equal to %{min}",
          "required": "Deceleration is required"
        },
        "max_moves": "You can only add up to 4 servo moves",
        "pause_time": "Pause time is required",
        "position": {
          "max": "Position must be less than or equal to %{max}",
          "min": "Position must be greater than or equal to %{min}",
          "required": "Position is required"
        },
        "velocity": {
          "max": "Velocity must be less than or equal to %{max}",
          "min": "Velocity must be greater than or equal to %{min}",
          "required": "Velocity is required"
        }
      },
      "velocity": "Velocity (m/s)"
    },
    "show": "Show",
    "simple_form": {
      "error_notification": {
        "default_message": "Please review the problems below:"
      },
      "no": "No",
      "required": {
        "mark": "*",
        "text": "required"
      },
      "yes": "Yes"
    },
    "sms_notifications": {
      "error_message": "Error message",
      "message": "Content",
      "message_type": "Message type",
      "order_number": "Order number",
      "phone_number": "Phone number",
      "sent_at": "Sent at",
      "status": "Status"
    },
    "stock_control": {
      "cooking_units": {
        "add_new": "Add new Cooking Unit",
        "empty": "Empty",
        "remove": "Remove Cooking Unit"
      },
      "oil_status": {
        "full": "Full",
        "half": "Half remaining",
        "low": "Needs replenishment",
        "marked_for_replenishment": "Marked for replenishment"
      },
      "plate_container": {
        "add": "Add",
        "adjust_stand": "Bowl stand %{slotNumber}",
        "amount_to_add": "Amount to add",
        "amount_to_remove": "Amount to remove",
        "below_zero": "Only %{remaining} bowls in the stand",
        "exceeds_capacity": "Stand holds %{max} bowls — only %{free} more fit",
        "in_stand": "In stand",
        "remove": "Remove",
        "stand_updated": "Bowl stand updated"
      },
      "product_container": {
        "amount": "Amount",
        "categories": "All Categories",
        "empty": "Empty",
        "expiry_date": "Expiration date",
        "go_to_dosing_logs": "Go to dosing logs",
        "notes": "Notes",
        "product": "Product",
        "recently_used_only": "Show only active in last 30 days",
        "remove_container": "Remove container",
        "remove_modal": {
          "text": "Container was successfully removed",
          "title": "Container removed"
        },
        "replace_container": "Replace container",
        "save_modal": {
          "text": "Product was successfully changed",
          "title": "Product changed"
        }
      },
      "replenishment": "Replenishment",
      "stock_control": "Stock Control",
      "tabs": {
        "bowls": "Bowls",
        "cooking_units": "Cooking Units",
        "liquid_products": "Mobile feeder",
        "oil": "Oil",
        "solid_products": "Fixed feeder"
      }
    },
    "submit": "Submit",
    "support": {
      "array": {
        "last_word_connector": ", and ",
        "two_words_connector": " and ",
        "words_connector": ", "
      }
    },
    "table_filters": {
      "any": "Any",
      "clear": "Clear",
      "filters": "Filters",
      "search": "Search"
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%Y-%m-%d %H:%M:%S",
        "full": "%Y-%m-%d %H:%M:%S",
        "full_no_seconds": "%Y-%m-%d %H:%M",
        "full_with_zone": "%Y-%m-%d %H:%M:%S %z",
        "long": "%B %d, %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "pm"
    },
    "units": {
      "no_records_heading": "No units yet"
    },
    "users": {
      "not_editable": "User is not editable"
    },
    "versioning": {
      "create_new_version": "Create new version",
      "created_from_version": "↩ from v%{version}",
      "delete_draft": "Delete draft",
      "delete_draft_confirm_body": "This cannot be undone.",
      "delete_draft_confirm_title": "Delete this draft?",
      "flash": {
        "already_a_draft": "This is already a draft",
        "deleted": "%{resource} deleted",
        "draft_already_exists": "A draft already exists in this lineage — edit or discard it first",
        "draft_created": "Draft v%{version} created from v%{source_version}",
        "in_use": "%{resource} is still in use and cannot be deleted",
        "only_archived_restorable": "Only archived versions can be restored",
        "published_and_synced": "Version published and synced with robot",
        "published_sync_failed": "Version published, but robot sync failed: %{error} — run \"Sync with robot\" from the Move modes page"
      },
      "not_a_draft": "Only drafts can be published",
      "origins": {
        "ai": "AI",
        "manual": "Manual"
      },
      "publish": "Publish",
      "publish_and_sync": "Publish & sync robot",
      "publish_confirm_title": "Publish this version?",
      "publish_failed": "Publishing failed",
      "read_only_notice": "This version is read-only — create a new version to make changes",
      "restore_confirm": "Create a new draft from v%{version}?",
      "restore_version": "Restore",
      "save_and_publish": "Save and publish",
      "statuses": {
        "archived": "Archived",
        "draft": "Draft",
        "published": "Published"
      },
      "versions": "Versions",
      "view_version": "View"
    },
    "views": {
      "pagination": {
        "first": "&laquo; First",
        "last": "Last &raquo;",
        "next": "Next &rsaquo;",
        "previous": "&lsaquo; Prev",
        "truncate": "&hellip;"
      }
    },
    "voucher": {
      "errors": {
        "technical_problems": "We're not accepting orders right now. Please try again later."
      },
      "technical_problems": {
        "body": "We're not accepting orders right now, so meals can't be ordered. Your voucher stays valid — please try again later.",
        "title": "Temporarily unavailable"
      }
    },
    "vouchers": {
      "cancelation_notes": {
        "emergency_stop": "Meal canceled by kitchen emergency stop",
        "queue_reset": "Order queue canceled by staff during robot reset"
      }
    }
  }
}